import { InjectionToken } from '@angular/core';

/**
 * Identifies this tab to the API: sent as `X-Client-Instance-Id` on every
 * HTTP request (`GraphQLModule`), and carried back on the realtime events
 * those requests cause (`IncidentEvent.clientInstanceId`). That tells the
 * echo of a change made here apart from the same user acting in another
 * window or on another device. One per page load — deliberately not stored,
 * so a duplicated tab gets its own.
 */
export const CLIENT_INSTANCE_ID = new InjectionToken<string>(
  'CLIENT_INSTANCE_ID',
  { providedIn: 'root', factory: () => crypto.randomUUID() }
);
